import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function TableSkeleton() {
  return (
    <div className="ab-card ab-shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-[#E2E8F0] flex gap-6">
        {["Task", "Category", "Due", "Status", "Document", "Updated"].map((h) => (
          <Skeleton key={h} className="h-3 w-16" />
        ))}
      </div>
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="px-4 py-3.5 border-b border-[#E2E8F0] flex items-center gap-6 last:border-b-0"
        >
          <Skeleton className="h-2 w-2 rounded-full" />
          <Skeleton className="h-3.5 w-56" />
          <Skeleton className="h-3.5 w-16" />
          <Skeleton className="h-3.5 w-20" />
          <Skeleton className="h-3.5 w-20" />
          <Skeleton className="h-3.5 w-16" />
          <Skeleton className="h-3.5 w-24 ml-auto" />
        </div>
      ))}
    </div>
  );
}
